import React from 'react';

import { useRoutes } from 'react-router-dom';
import * as z from 'zod';

import { useToken } from 'src/features/auth';
import AuthContext from 'src/features/auth/context/AuthContext';
import { FallbackBlock } from 'src/registry/components/blocks/FallbackBlock';
import { protectedRoutes } from 'src/routes/protected';
import { publicRoutes } from 'src/routes/public';
import { useZodCustomErrorMap } from 'src/utils/errors';

export const AppRoutes = () => {
    const { zodCallback } = useZodCustomErrorMap();
    z.setErrorMap(zodCallback);

    const { data, isPending } = useToken();
    const { permissionsLoaded } = React.useContext(AuthContext);

    const routes = data ? protectedRoutes : publicRoutes;

    const element = useRoutes(routes);

    if (isPending || !permissionsLoaded) return <FallbackBlock />;
    return <>{element}</>;
};
